import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { aggregateFieldsIcon, gearIcon, pencilIcon, plusIcon} from "@progress/kendo-svg-icons";
import i18next from 'i18next';
import { isIOS } from '../../../utils';
import { IsEnglish } from '../../../utils/language';
import styles from '../../../styles/scheduleAvailability.module.css';

const useStyles = makeStyles((theme) => ({
    buttons: {
        float: 'left',
        '& > div': {
            zIndex: '100'
        },
        '@media (max-width: 600px)': {
            float: 'unset'
        }
    },
    divPeriod: {
        float: 'right',
        '@media (max-width: 600px)': {
            float: 'left',
            marginTop: '15px',
            marginBottom: '5px'
        }
    },
    row1: {
        display: 'flow-root'
    },
    divComment: {
        height: '65px',
        overflowY: 'scroll',
        position: 'relative',
        border: '1px solid #bdbdbd',
        width: '100%',
        padding: '5px',
        marginTop: '10px',
        marginBottom: '10px'
    },
    button: {
        borderColor: 'var(--color1)',
        backgroundColor: 'var(--color1)',
        color: 'var(--color2)',
        '&:hover': {
            backgroundColor: 'var(--color1)'
        }
    }
}));

export function HeaderAvailability(props) {
    const classes = useStyles();
    const [period, setPeriod] = React.useState(0);
    const [dataPeriod, setDataPeriod] = React.useState([]);
    const [comment, setComment] = React.useState('');
    const [hasAvailability, setHasAvailability] = React.useState(false);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        if (props.dataPeriod.length > 0) {
            loadPeriod();

            if (period == 0) {
                // select the first period by default
                setPeriod(props.dataPeriod[0].id);
            }
        }

        if (period > 0) {
            handleCommentPeriod(period);
        }
    }, [props.dataPeriod]);

    useEffect(() => {
        setHasAvailability(props.hasAvailability);
    }, [props.hasAvailability]);

    useEffect(() => {
        if (period > 0 && props.listRef) {
            handleLoadList(period);
            handleCommentPeriod(period);
        }
    }, [period, props.listRef]);

    const handleCommentPeriod = (period) => {
        const comment = props.dataPeriod.filter(x => x.id == period)[0].comment;
        props.setComment(comment);
        setComment(comment);
    }

    const handleEditPeriod = (id) => {
        props.handleEditPeriod(id);
    }

    const handleEditAvailability = () => {
        props.handleEditAvailability();
    }

    const handleCreateTemplate = () => {
        props.handleCreateTemplate();
    }

    const handleLoadList = (id) => {
        props.handleLoadList(period);
    }

    const loadPeriod = () => {
        setDataPeriod(props.dataPeriod);
    }

    const handleClick = (eventType) => {
        switch (eventType.itemIndex) {
            case 3:
                // Add availability
                handleEditAvailability();
                break;
            case 2:
                // Add period
                handleEditPeriod(0);
                break;
            case 1:
                // Edit period
                handleEditPeriod(period);
                break;
            case 0:
                // Create from template
                handleCreateTemplate();
                break;
            default:
                break;
        }
    };

    const handleChangePeriod = (event) => {
        setPeriod(event.target.value);
    }

    const items = [
        {
            svgIcon: aggregateFieldsIcon,
            text: i18next.t('scheduleAvailability:button.createTemplate'),
            disabled: hasAvailability
            
        },
        {
            svgIcon: pencilIcon,
            text: i18next.t('scheduleAvailability:button.editPeriod'),
            disabled: period == 0
        },
        {
            svgIcon: plusIcon,
            text: i18next.t('scheduleAvailability:button.addPeriod'),
            disabled: false
        },
        {
            svgIcon: plusIcon,
            text: i18next.t('buttons:add'),
            disabled: period == 0
        },
    ];

    return (
        <div className={styles.headerScheduleAvailability}>
            <div className={classes.row1}>
                <div className={classes.divPeriod}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="label-period">{i18next.t('scheduleAvailability:periodLabel')}</InputLabel>
                        <Select
                            labelId="label-period"
                            id="period"
                            value={period || ''}
                            onChange={handleChangePeriod}
                            label={i18next.t('scheduleAvailability:period')}
                        >
                            {dataPeriod && dataPeriod.map((obj, index) =>
                                <MenuItem key={index} className={styles.selectItem} value={obj.id}>{IsEnglish() ? `${obj.descriptionE}` : `${obj.descriptionF}`}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <div>
                        <FloatingActionButton className={`addButtonFab floatingActionButton ${isiOS && "addButtonFabIOS"}`} svgIcon={gearIcon} items={items} onItemClick={handleClick} />
                    </div>
                </div>
            </div>
            {comment && <div className={classes.divComment}>
                <span>{i18next.t('scheduleAvailability:period.message.periodComment')}{i18next.t('common:labelSeparator')} </span>
                <span>{comment}</span>
            </div>}
        </div>
    );
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'common'], { wait: true })(HeaderAvailability);